import type { DefineComponent, ComponentOptionsMixin, ComputedOptions, MethodOptions } from 'vue'

import FormTemplate from './questionnaireTemplateV3.vue'
import InputBoxV3 from './formElements/fields/inputBoxV3.vue'
import TextAreaV3 from './formElements/fields/textAreaV3.vue'
import RadioButtonV3 from './formElements/fields/radioButtonV3.vue'
import CheckBoxV3 from './formElements/fields/checkBoxV3.vue'
import InfoBlockV3 from './formElements/fields/infoBlockV3.vue'
import CalendarV3 from './formElements/fields/calendarV3.vue'
import FileFieldV3 from './formElements/fields/dropzoneV3.vue'
import FormResultV3 from './formElements/formResultV3.vue'

type FlexibleComponent = DefineComponent<
  any,
  any,
  any,
  ComputedOptions,
  MethodOptions,
  ComponentOptionsMixin,
  ComponentOptionsMixin,
  any,
  string,
  any
>

type ComponentMap = Record<string, FlexibleComponent | undefined>

const COMPONENT_MAP: ComponentMap = {
  formTemplate: FormTemplate,
  textinput: InputBoxV3,
  textarea: TextAreaV3,
  radio: RadioButtonV3,
  select: RadioButtonV3,
  information: InfoBlockV3,
  datefield: CalendarV3,
  timefield: InputBoxV3,
  multiselect: CheckBoxV3,
  filefield: FileFieldV3,
  multifilefield: FileFieldV3,
  formResult: FormResultV3,
  emailinput: InputBoxV3,
  phoneinput: InputBoxV3,
  numberinput: InputBoxV3,
  decimalnumberinput: InputBoxV3,
  urlinput: InputBoxV3,
  yesno: RadioButtonV3
}

export function getComponent(type: string): FlexibleComponent | undefined {
  return COMPONENT_MAP[type]
}
